package com.milta.feature.auth.presentation

data class OtpState(
    val code: String = "",
    val isLoading: Boolean = false,
    val error: String? = null,
    val resendCountdown: Int = 60,
    val attempts: Int = 0,
    val isResendBlocked: Boolean = false,
)
